import { useLang } from "@/lib/i18n";
import { CATEGORIES, CATEGORY_COLORS, money } from "./expenseUtils";

export const MonthStats = ({ monthItems }) => {
  const { t, lang } = useLang();
  const total = monthItems.reduce((s, e) => s + e.amount, 0);
  const byCat = monthItems.reduce((acc, e) => {
    acc[e.category] = (acc[e.category] || 0) + e.amount;
    return acc;
  }, {});
  const top = Object.entries(byCat).sort((a, b) => b[1] - a[1])[0];
  const monthLabel = new Date().toLocaleString(lang === "es" ? "es-US" : "en-US", {
    month: "long",
    year: "numeric",
  });

  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6 mb-8">
      <div
        className="sm:col-span-2 rounded-3xl bg-[#F26522] p-6 sm:p-8 relative overflow-hidden"
        data-testid="stat-month-total"
      >
        <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-white/80">
          {t("exp_month_total")} · {monthLabel}
        </p>
        <p className="mt-2 font-display font-extrabold text-4xl sm:text-5xl text-white tabular-nums">
          {money(total)}
        </p>
        <p className="mt-2 text-sm text-white/80" data-testid="stat-month-count">
          {monthItems.length} {t("exp_month_count")}
        </p>
        <div className="mt-5 flex h-2 w-full overflow-hidden rounded-full bg-white/20">
          {CATEGORIES.filter((c) => byCat[c]).map((c) => (
            <span
              key={c}
              style={{ width: `${(byCat[c] / total) * 100}%`, backgroundColor: CATEGORY_COLORS[c] }}
              className="h-full border-r border-[#F26522]/40 last:border-0"
            />
          ))}
        </div>
      </div>
      <div className="rounded-3xl bg-[#132338] border border-[#203859] p-6" data-testid="stat-top-category">
        <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-slate-400">
          {t("exp_top_category")}
        </p>
        {top ? (
          <>
            <p className="mt-2 font-display font-extrabold text-2xl text-white flex items-center gap-2">
              <span
                className="h-3 w-3 rounded-full"
                style={{ backgroundColor: CATEGORY_COLORS[top[0]] }}
              />
              {t(`cat_${top[0]}`)}
            </p>
            <p className="mt-1 font-display font-bold text-[#F26522] tabular-nums">{money(top[1])}</p>
          </>
        ) : (
          <p className="mt-2 font-display font-extrabold text-2xl text-slate-600">—</p>
        )}
      </div>
    </div>
  );
};
